<section class="doners w-full max-w-6xl mx-auto px-3 md:px-6 py-6 space-y-6" dir="rtl">

  <header class="flex flex-col gap-1">
    <p class="text-base text-ink-500">בית כנסת</p>
    <h1 class="text-3xl font-bold text-primary-700">{{ header }}</h1>
  </header>

  <!-- Donors list — mobile cards + tablet+ table -->
  <ng-container *ngIf="doners?.length; else empty">

    <!-- ── Mobile cards (< md) ─────────────────────────────────── -->
    <div class="md:hidden space-y-2">
      <div *ngFor="let doner of doners" class="card-2026 !p-3">
        <div class="flex justify-between items-start gap-3">
          <div class="min-w-0 flex-1">
            <div class="font-bold text-ink-800 text-base truncate">{{ doner.fullName }}</div>
            <div class="text-xs text-ink-500 mt-1">
              {{ doner.createdAt | date : 'd בMMM y' : '' : 'he-IL' }}
            </div>
            <div *ngIf="doner.contact" class="text-sm mt-1">
              <a [href]="'tel:' + doner.contact" class="text-primary-600 hover:underline">
                <i class="material-symbols-outlined !text-base align-middle" aria-hidden="true">call</i>
                {{ doner.contact }}
              </a>
            </div>
          </div>
          <div class="money money--credit font-bold text-lg shrink-0">
            {{ doner.amountDonated | currency : 'ILS' : 'symbol' : '1.0-0' }}
          </div>
        </div>
      </div>
    </div>

    <!-- ── Tablet+ table (≥ md) ────────────────────────────────── -->
    <div class="hidden md:block overflow-x-auto">
      <table class="table-2026 w-full">
        <thead>
          <tr>
            <th>שם מלא</th>
            <th class="text-end">סכום</th>
            <th>טלפון</th>
            <th>תאריך</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let doner of doners">
            <td class="font-semibold">{{ doner.fullName }}</td>
            <td class="text-end money money--credit font-semibold">
              {{ doner.amountDonated | currency : 'ILS' : 'symbol' : '1.0-0' }}
            </td>
            <td>
              <a *ngIf="doner.contact; else noContact"
                 [href]="'tel:' + doner.contact"
                 class="text-primary-600 hover:underline">
                {{ doner.contact }}
              </a>
              <ng-template #noContact><span class="text-ink-400">—</span></ng-template>
            </td>
            <td>{{ doner.createdAt | date : 'd בMMM y' : '' : 'he-IL' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <ng-template #empty>
    <div class="card-2026 text-center py-12">
      <i class="material-symbols-outlined text-5xl text-ink-300 mb-2" aria-hidden="true">volunteer_activism</i>
      <h2 class="text-xl font-semibold text-ink-700">אין עדיין תורמים</h2>
      <p class="text-base text-ink-500 mt-1">הוסף תורם כדי שיופיע ברשימה</p>
    </div>
  </ng-template>

  <!-- Add donor form -->
  <div class="addDoner">
    <app-add-doner></app-add-doner>
  </div>
</section>
